<!--
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-09-29 10:55:01
 * @LastEditors: loong
 * @LastEditTime: 2022-09-30 16:58:22
-->
<template>
  <div style="display: flex;flex-direction: column;height: 97%;">
    <div class="dataShow_rankBox">
      <div class="dataShow_rankItem" v-for="(item, index) in acceptGoods" :key="index" @click="toDetail(item.goodsId)">
        <span class="dataShow_rankItemNub" :style="{background: index < 3 ? 'url(' + require('@/assets/imgs/RemoteSensingMall/hot.png') + ')' + ' no-repeat': 'url(' + require('@/assets/imgs/RemoteSensingMall/common.png') + ')' + ' no-repeat'}" :class="{numcolor: index < 3}">{{ index + 1 }}</span>
        <div class="dataShow_rankItemText of-1" :title="item.goodsName">
          {{item.goodsName}}
        </div>
        <div class="dataShow_rankItemHot">
          <el-image style="width: 20px; height: 20px" :src="hotImg" fit="cover" v-if="index < 3"></el-image>
        </div>
      </div>
    </div>
<!--    <div class="dataShow_saleDataBox">-->
<!--      <div class="dataShow_saleData">-->
<!--        <div class="dataShow_saleDataInfo"><span class="img"><img src="@/assets/imgs/RemoteSensingMall/zx.png" alt=""></span><span class="name">今日销售次数</span></div>-->
<!--        <div class="dataShow_saleDataNumber">{{ todayCount }}</div>-->
<!--      </div>-->
<!--      <div class="dataShow_saleData">-->
<!--        <div class="dataShow_saleDataInfo"><span class="img"><img src="@/assets/imgs/RemoteSensingMall/pie.png" alt=""></span><span class="name">总销售次数</span></div>-->
<!--        <div class="dataShow_saleDataNumber">{{ allCount }}</div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<script>
  export default {
    components: {},
    props: ['todayCount','allCount'],
    data() {
      return {
        hotImg: require("@/assets/imgs/RemoteSensingMall/fire.png"),
        getNum: 10,
        acceptGoods: []
      };
    },
    computed: {

    },
    created() {
    },
    mounted() {
      // 初始化排行榜
      this.initGoodsRankList();
    },
    methods: {
      toDetail(goodsId) {
        this.$router.push({
          path: "/shopDetail",
          query: {
            goodsId: goodsId
          }
        });
      },
      initGoodsRankList() {
        this.$http.get(this.$const.RemoteSensingMall.GoodsRankList + this.getNum, '').then(res => {
          // console.log(res);
          if (res.code == 200) {
            this.acceptGoods = res.data;
          } else {
            this.$message.error(this.$PubText.getInfoFail)
          }
        }).catch(error => {
          this.$message.error(this.$PubText.InterfaceFail)
        })
      }
    },
  };
</script>
<style lang="scss" scoped>
  .dataShow_rankBox {
    border-bottom: 1px dashed #ccc;
    font-size: 14px;
    margin-bottom: 10px;
    flex: 1;
    overflow: auto;
  }

  .dataShow_rankItemHot {
    width: 15%;
    text-align: center;
  }

  .dataShow_rankItemText {
    width: 100%;
  }

  .dataShow_rankItemNub {
    width: 44px;
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    color: #2569F2;
    font-size: 20px;
    font-family: Nexa-XBold
  }
  .numcolor {
    color: #FFFFFF;
  }

  .dataShow_rankItem:nth-child(-n + 3) {
    color: #2469f1;
  }

  .dataShow_rankItem:hover {
    color: #2469f1;
  }

  .dataShow_rankItem {
    width: 100%;
    height: 60px;
    line-height: 60px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    cursor: pointer;
  }

  .dataShow_rankTitle {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .dataShow_saleDataInfo {
    font-size: 14px;
    margin: 5px 0;
    span.img {
      vertical-align: -8px;
    }
    span.name {
      margin-left: 10px;
      font-size: 16px;
      font-family: MicrosoftYaHeiUI;;
    }
  }

  .dataShow_saleDataNumber {
    margin: 5px 0;
    font-size: 18px;
    font-weight: bold;
    font-size: 32px;
    font-family: Nexa-XBold;
    font-weight: normal;
    color: #2569F2;
  }

  .dataShow_saleData {
    width: 100%;
    height: 4.5em;
    background: #dfe9fd;
    border-radius: 4px;
    margin: 10px 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .dataShow_saleDataBox {
    height: 190px;
    margin-top: 0.1em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    //display: flex;
    //flex-wrap: nowrap;
    //justify-content: space-between;
    //align-items: center;
  }
</style>
